module.exports = __webpack_public_path__ + "img/yellow.07ec7e7a.png";